import styled from 'styled-components';

const HomeBgWrapper = styled.div`
    background-image: url('/image/bg_paper.png');
    background-color: #F9F4EF;
`;

export default HomeBgWrapper;
